exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-6a131c96] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n.page-container[data-v-6a131c96] {\n  padding: 16px 32px 32px;\n  margin-top: 67px;\n  min-height: calc(100vh - 67px);\n  background: #f7f7f8;\n}\n.other-details[data-v-6a131c96] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n}\n", ""]);

// exports
